<template>
  <div class="mb-12 max-w-lg mx-auto">
    <form
      class="border-2 border-grey-200 text-lg"
      @submit.prevent="uploadPresentation"
    >
      <label
        for="presentation_upload"
        class="block -mt-4 ml-4 uppercase text-sm text-grey-600 font-bold"
      >
        <span
          class="inline-block bg-grey-100 py-1 px-2"
        >Presentation Upload</span>
      </label>
      <div
        v-if="!presentation.length"
        class="flex mx-4 mb-3 items-center justify-center"
      >
        <input
          id="presentation_upload"
          ref="presentation"
          type="file"
          name="presentation_upload"
          class="w-full ml-2"
          :disabled="!canUpload"
          accept=".ppt,.pptx,.pdf"
        />
        <button
          type="submit"
          class="flex-1 py-2 px-6 uppercase text-sm font-bold"
          :class="{
            'bg-primary-700 text-white': !loading && canUpload,
            'bg-grey-200 text-grey-800 cursor-not-allowed':
              loading || !canUpload
          }"
        >
          <span v-if="!loading">
            Upload
          </span>
          <span v-else>
            Uploading...
          </span>
        </button>
      </div>
      <div
        v-else
        class="flex mx-6 mb-3 mt-1"
      >
        <button
          v-if="canUpload"
          type="button"
          class="p-0 mr-2 cursor-pointer"
          @click="removePresentation('presentation', 0, presentation[0].id)"
        >
          <icon
            icon="close-circle"
            class="w-5 h-5 icons-negative block m-0"
          />
        </button>
        <span
          class="flex-1"
        >{{ presentation[0].name }}
          <small>[{{ presentation[0].size }}]</small></span>
        <icon-link
          :href="downloadPresentation(presentation[0].id)"
          target="_blank"
          icon="cheveron-down-circle"
          icon-placement="right"
        >
          Download
        </icon-link>
      </div>
    </form>
    <p
      v-if="!presentation.length"
      class="mx-5 mt-4 text-xs text-primary-600 font-bold"
    >
      <icon
        icon="important"
        class="w-4 h-4 icons-primary align-middle mr-1"
      />
      Please make sure that your presentation is less the 50mb and is a PDF or
      Powerpoint Presentation (PPT/PPTX)
    </p>
  </div>
</template>
<script>
export default {
  name: "ApplicationPresentationUpload",
  props: {
    project: {
      type: [Object],
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      presentation: []
    };
  },
  computed: {
    canUpload() {
      return !this.user.is_monitor && this.project.invited_at && !this.loading;
    }
  },
  created() {
    if (this.project.hasOwnProperty("presentation")) {
      this.presentation = this.project.presentation;
    }
  },
  methods: {
    validFile(file) {
      const errors = [];

      if (file.size / 1024 / 1024 > 50)
        errors.push(`This file exceeds the upload limit of 50mb`);

      if (errors.length) {
        file["errors"] = errors;
      }
      return file;
    },
    downloadPresentation(id, project = true) {
      let append = project ? "?project=1" : "";
      return (
        route("applications.files.download", {
          application: window._project,
          file: id
        }) + append
      );
    },
    removePresentation(fieldKey, index, id) {
      if (!this.canUpload) return;
      axios
        .delete(
          route("applications.files.delete", {
            application: window._project,
            file: id
          })
        )
        .then(() => {
          this.presentation = [];
        })
        .catch(error => console.log(error));
    },
    uploadPresentation() {
      const inputFiles = this.$refs.presentation.files;

      if (!this.canUpload || !inputFiles.length) return;

      let formData = new FormData();
      this.loading = true;

      formData.append("parent_key", "presentation_upload");
      formData.append("key", "presentation");

      for (let i = 0; i < inputFiles.length; i++) {
        let file = this.validFile(inputFiles[i]);
        if (file.hasOwnProperty("errors")) {
          alert(file.errors[0]);
        } else {
          formData.append(`presentation[${i}]`, file);
        }
      }

      axios
        .post(route("applications.upload", window._project), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(({ data }) => {
          formData = null;
          this.$refs.presentation.setAttribute("files", null);
          this.$refs.presentation.setAttribute("value", "");
          this.loading = false;
          this.presentation = data;
        })
        .catch(({ response, data }) => {
          window.alert("Unable to upload your presentation");
        });
    }
  }
};
</script>
